import React, {Component} from 'react';
import {Modal} from 'semantic-ui-react';

class DeleteModal extends Component {
  render() {
    const {deleteFunction, trigger, title} = this.props;
    return (
      <Modal
        size='mini'
        trigger={<span>{trigger}</span>}
        header={`¿Está seguro que desea ${title}?`}
        actions={[
          {'key': 'cancel', 'content': 'Cancelar'},
          {'key': 'done', 'content': 'Confirmar', 'positive': true,
            'onClick': deleteFunction,
            'primary': true,
          },
        ]}
      />
    );
  }
}

export default DeleteModal;
